"use strict";
// tslint:disable
/**
 * Unimaze\'s Identity Server api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalImportUrl = __importStar(require("url"));
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 * AccountApi - axios parameter creator
 * @export
 */
exports.AccountApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Impersonates specified user
         * @param {string} aspNetUserId
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountImpersonateByAspNetUserIdGet: function (aspNetUserId, redirectUrl, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'aspNetUserId' is not null or undefined
            if (aspNetUserId === null || aspNetUserId === undefined) {
                throw new base_1.RequiredError('aspNetUserId', 'Required parameter aspNetUserId was null or undefined when calling accountImpersonateByAspNetUserIdGet.');
            }
            var localVarPath = "/account/impersonate/{aspNetUserId}"
                .replace("{" + "aspNetUserId" + "}", encodeURIComponent(String(aspNetUserId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (redirectUrl !== undefined) {
                localVarQueryParameter['redirectUrl'] = redirectUrl;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * AccountApi - functional programming interface
 * @export
 */
exports.AccountApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Impersonates specified user
         * @param {string} aspNetUserId
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountImpersonateByAspNetUserIdGet: function (aspNetUserId, redirectUrl, options) {
            var localVarAxiosArgs = exports.AccountApiAxiosParamCreator(configuration).accountImpersonateByAspNetUserIdGet(aspNetUserId, redirectUrl, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * AccountApi - factory interface
 * @export
 */
exports.AccountApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Impersonates specified user
         * @param {string} aspNetUserId
         * @param {string} [redirectUrl]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accountImpersonateByAspNetUserIdGet: function (aspNetUserId, redirectUrl, options) {
            return exports.AccountApiFp(configuration).accountImpersonateByAspNetUserIdGet(aspNetUserId, redirectUrl, options)(axios, basePath);
        },
    };
};
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Impersonates specified user
     * @param {string} aspNetUserId
     * @param {string} [redirectUrl]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.accountImpersonateByAspNetUserIdGet = function (aspNetUserId, redirectUrl, options) {
        return exports.AccountApiFp(this.configuration).accountImpersonateByAspNetUserIdGet(aspNetUserId, redirectUrl, options)(this.axios, this.basePath);
    };
    return AccountApi;
}(base_1.BaseAPI));
exports.AccountApi = AccountApi;
/**
 * UsersApi - axios parameter creator
 * @export
 */
exports.UsersApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Reset user password - for host/admin users only
         * @param {HostResetPasswordModel} [model]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountHostresetpasswordPost: function (model, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/account/hostresetpassword";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof model !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(model !== undefined ? model : {}) : (model || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates user and context information (profile, actor etc.) from provided data
         * @param {CreateActorUser} [createActorUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountOwnerUsersPost: function (createActorUser, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/account/owner/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof createActorUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createActorUser !== undefined ? createActorUser : {}) : (createActorUser || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get profile departments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/departments";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Look up for users from owner role.
         * @param {string} [name]
         * @param {string} [userName]
         * @param {string} [personIsoIdentifier]
         * @param {boolean} [showDisabled]
         * @param {string} [roles]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OwnerUsersGet: function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/owner/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (userName !== undefined) {
                localVarQueryParameter['UserName'] = userName;
            }
            if (personIsoIdentifier !== undefined) {
                localVarQueryParameter['PersonIsoIdentifier'] = personIsoIdentifier;
            }
            if (showDisabled !== undefined) {
                localVarQueryParameter['ShowDisabled'] = showDisabled;
            }
            if (roles !== undefined) {
                localVarQueryParameter['Roles'] = roles;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get role by name.
         * @param {string} roleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesByRoleNameGet: function (roleName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'roleName' is not null or undefined
            if (roleName === null || roleName === undefined) {
                throw new base_1.RequiredError('roleName', 'Required parameter roleName was null or undefined when calling apiV1RolesByRoleNameGet.');
            }
            var localVarPath = "/api/v1/roles/{roleName}"
                .replace("{" + "roleName" + "}", encodeURIComponent(String(roleName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all roles of a user.
         * @param {string} userName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesByUserNameRolesGet: function (userName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new base_1.RequiredError('userName', 'Required parameter userName was null or undefined when calling apiV1RolesByUserNameRolesGet.');
            }
            var localVarPath = "/api/v1/roles/{userName}/roles"
                .replace("{" + "userName" + "}", encodeURIComponent(String(userName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/roles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes user by user id.  DELETE: api/users/{userId}
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDelete: function (userId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdDelete.');
            }
            var localVarPath = "/api/v1/users/{userId}"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Removes the actor for the provided userId and actorId
         * @param {string} userId
         * @param {number} actorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDepartmentsByActorIdDelete: function (userId, actorId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdDepartmentsByActorIdDelete.');
            }
            // verify required parameter 'actorId' is not null or undefined
            if (actorId === null || actorId === undefined) {
                throw new base_1.RequiredError('actorId', 'Required parameter actorId was null or undefined when calling apiV1UsersByUserIdDepartmentsByActorIdDelete.');
            }
            var localVarPath = "/api/v1/users/{userId}/departments/{actorId}"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)))
                .replace("{" + "actorId" + "}", encodeURIComponent(String(actorId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Adds an actor for provided userId and returns it
         * @param {string} userId
         * @param {CreateActor} [createActor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDepartmentsPost: function (userId, createActor, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdDepartmentsPost.');
            }
            var localVarPath = "/api/v1/users/{userId}/departments"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof createActor !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createActor !== undefined ? createActor : {}) : (createActor || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdGet: function (userId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdGet.');
            }
            var localVarPath = "/api/v1/users/{userId}"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesDelete: function (userId, role, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdRolesDelete.');
            }
            var localVarPath = "/api/v1/users/{userId}/roles"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesPost: function (userId, role, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdRolesPost.');
            }
            var localVarPath = "/api/v1/users/{userId}/roles"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (role !== undefined) {
                localVarQueryParameter['role'] = role;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update roles.
         * @param {string} userId
         * @param {string} [roles]
         * @param {boolean} [notifyUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesPut: function (userId, roles, notifyUser, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersByUserIdRolesPut.');
            }
            var localVarPath = "/api/v1/users/{userId}/roles"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (roles !== undefined) {
                localVarQueryParameter['roles'] = roles;
            }
            if (notifyUser !== undefined) {
                localVarQueryParameter['notifyUser'] = notifyUser;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Returns user by user name.
         * @param {string} userName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserNameGet: function (userName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new base_1.RequiredError('userName', 'Required parameter userName was null or undefined when calling apiV1UsersByUserNameGet.');
            }
            var localVarPath = "/api/v1/users/{userName}"
                .replace("{" + "userName" + "}", encodeURIComponent(String(userName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Disable user by user id.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersDisableByUserIdPut: function (userId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersDisableByUserIdPut.');
            }
            var localVarPath = "/api/v1/users/disable/{userId}"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Enable user by user id.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersEnableByUserIdPut: function (userId, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new base_1.RequiredError('userId', 'Required parameter userId was null or undefined when calling apiV1UsersEnableByUserIdPut.');
            }
            var localVarPath = "/api/v1/users/enable/{userId}"
                .replace("{" + "userId" + "}", encodeURIComponent(String(userId)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Look up for users.
         * @param {string} [name]
         * @param {string} [userName]
         * @param {string} [personIsoIdentifier]
         * @param {boolean} [showDisabled]
         * @param {string} [roles]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersGet: function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (userName !== undefined) {
                localVarQueryParameter['UserName'] = userName;
            }
            if (personIsoIdentifier !== undefined) {
                localVarQueryParameter['PersonIsoIdentifier'] = personIsoIdentifier;
            }
            if (showDisabled !== undefined) {
                localVarQueryParameter['ShowDisabled'] = showDisabled;
            }
            if (roles !== undefined) {
                localVarQueryParameter['Roles'] = roles;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Creates a user.
         * @param {CreateUser} [createUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersPost: function (createUser, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'POST' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof createUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(createUser !== undefined ? createUser : {}) : (createUser || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Update a user.
         * @param {UpdateUser} [updateUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersPut: function (updateUser, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/users";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof updateUser !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(updateUser !== undefined ? updateUser : {}) : (updateUser || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get all available users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSelfGet: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/users/self";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UsersApi - functional programming interface
 * @export
 */
exports.UsersApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Reset user password - for host/admin users only
         * @param {HostResetPasswordModel} [model]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountHostresetpasswordPost: function (model, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1AccountHostresetpasswordPost(model, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates user and context information (profile, actor etc.) from provided data
         * @param {CreateActorUser} [createActorUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountOwnerUsersPost: function (createActorUser, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1AccountOwnerUsersPost(createActorUser, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get profile departments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsGet: function (options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1DepartmentsGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Look up for users from owner role.
         * @param {string} [name]
         * @param {string} [userName]
         * @param {string} [personIsoIdentifier]
         * @param {boolean} [showDisabled]
         * @param {string} [roles]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OwnerUsersGet: function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1OwnerUsersGet(name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get role by name.
         * @param {string} roleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesByRoleNameGet: function (roleName, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1RolesByRoleNameGet(roleName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all roles of a user.
         * @param {string} userName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesByUserNameRolesGet: function (userName, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1RolesByUserNameRolesGet(userName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesGet: function (options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1RolesGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Deletes user by user id.  DELETE: api/users/{userId}
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDelete: function (userId, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdDelete(userId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Removes the actor for the provided userId and actorId
         * @param {string} userId
         * @param {number} actorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDepartmentsByActorIdDelete: function (userId, actorId, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdDepartmentsByActorIdDelete(userId, actorId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Adds an actor for provided userId and returns it
         * @param {string} userId
         * @param {CreateActor} [createActor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDepartmentsPost: function (userId, createActor, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdDepartmentsPost(userId, createActor, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdGet: function (userId, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdGet(userId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesDelete: function (userId, role, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdRolesDelete(userId, role, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @param {string} userId
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesPost: function (userId, role, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdRolesPost(userId, role, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update roles.
         * @param {string} userId
         * @param {string} [roles]
         * @param {boolean} [notifyUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesPut: function (userId, roles, notifyUser, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserIdRolesPut(userId, roles, notifyUser, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Returns user by user name.
         * @param {string} userName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserNameGet: function (userName, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersByUserNameGet(userName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Disable user by user id.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersDisableByUserIdPut: function (userId, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersDisableByUserIdPut(userId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Enable user by user id.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersEnableByUserIdPut: function (userId, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersEnableByUserIdPut(userId, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Look up for users.
         * @param {string} [name]
         * @param {string} [userName]
         * @param {string} [personIsoIdentifier]
         * @param {boolean} [showDisabled]
         * @param {string} [roles]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersGet: function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersGet(name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Creates a user.
         * @param {CreateUser} [createUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersPost: function (createUser, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersPost(createUser, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Update a user.
         * @param {UpdateUser} [updateUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersPut: function (updateUser, options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersPut(updateUser, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get all available users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSelfGet: function (options) {
            var localVarAxiosArgs = exports.UsersApiAxiosParamCreator(configuration).apiV1UsersSelfGet(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * UsersApi - factory interface
 * @export
 */
exports.UsersApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Reset user password - for host/admin users only
         * @param {HostResetPasswordModel} [model]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountHostresetpasswordPost: function (model, options) {
            return exports.UsersApiFp(configuration).apiV1AccountHostresetpasswordPost(model, options)(axios, basePath);
        },
        /**
         *
         * @summary Creates user and context information (profile, actor etc.) from provided data
         * @param {CreateActorUser} [createActorUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1AccountOwnerUsersPost: function (createActorUser, options) {
            return exports.UsersApiFp(configuration).apiV1AccountOwnerUsersPost(createActorUser, options)(axios, basePath);
        },
        /**
         *
         * @summary Get profile departments.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1DepartmentsGet: function (options) {
            return exports.UsersApiFp(configuration).apiV1DepartmentsGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Look up for users from owner role.
         * @param {string} [name]
         * @param {string} [userName]
         * @param {string} [personIsoIdentifier]
         * @param {boolean} [showDisabled]
         * @param {string} [roles]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1OwnerUsersGet: function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
            return exports.UsersApiFp(configuration).apiV1OwnerUsersGet(name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Get role by name.
         * @param {string} roleName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesByRoleNameGet: function (roleName, options) {
            return exports.UsersApiFp(configuration).apiV1RolesByRoleNameGet(roleName, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all roles of a user.
         * @param {string} userName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesByUserNameRolesGet: function (userName, options) {
            return exports.UsersApiFp(configuration).apiV1RolesByUserNameRolesGet(userName, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1RolesGet: function (options) {
            return exports.UsersApiFp(configuration).apiV1RolesGet(options)(axios, basePath);
        },
        /**
         *
         * @summary Deletes user by user id.  DELETE: api/users/{userId}
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDelete: function (userId, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdDelete(userId, options)(axios, basePath);
        },
        /**
         *
         * @summary Removes the actor for the provided userId and actorId
         * @param {string} userId
         * @param {number} actorId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDepartmentsByActorIdDelete: function (userId, actorId, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdDepartmentsByActorIdDelete(userId, actorId, options)(axios, basePath);
        },
        /**
         *
         * @summary Adds an actor for provided userId and returns it
         * @param {string} userId
         * @param {CreateActor} [createActor]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdDepartmentsPost: function (userId, createActor, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdDepartmentsPost(userId, createActor, options)(axios, basePath);
        },
        /**
         *
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdGet: function (userId, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdGet(userId, options)(axios, basePath);
        },
        /**
         *
         * @param {string} userId
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesDelete: function (userId, role, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdRolesDelete(userId, role, options)(axios, basePath);
        },
        /**
         *
         * @param {string} userId
         * @param {string} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesPost: function (userId, role, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdRolesPost(userId, role, options)(axios, basePath);
        },
        /**
         *
         * @summary Update roles.
         * @param {string} userId
         * @param {string} [roles]
         * @param {boolean} [notifyUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserIdRolesPut: function (userId, roles, notifyUser, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserIdRolesPut(userId, roles, notifyUser, options)(axios, basePath);
        },
        /**
         *
         * @summary Returns user by user name.
         * @param {string} userName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersByUserNameGet: function (userName, options) {
            return exports.UsersApiFp(configuration).apiV1UsersByUserNameGet(userName, options)(axios, basePath);
        },
        /**
         *
         * @summary Disable user by user id.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersDisableByUserIdPut: function (userId, options) {
            return exports.UsersApiFp(configuration).apiV1UsersDisableByUserIdPut(userId, options)(axios, basePath);
        },
        /**
         *
         * @summary Enable user by user id.
         * @param {string} userId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersEnableByUserIdPut: function (userId, options) {
            return exports.UsersApiFp(configuration).apiV1UsersEnableByUserIdPut(userId, options)(axios, basePath);
        },
        /**
         *
         * @summary Look up for users.
         * @param {string} [name]
         * @param {string} [userName]
         * @param {string} [personIsoIdentifier]
         * @param {boolean} [showDisabled]
         * @param {string} [roles]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersGet: function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
            return exports.UsersApiFp(configuration).apiV1UsersGet(name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Creates a user.
         * @param {CreateUser} [createUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersPost: function (createUser, options) {
            return exports.UsersApiFp(configuration).apiV1UsersPost(createUser, options)(axios, basePath);
        },
        /**
         *
         * @summary Update a user.
         * @param {UpdateUser} [updateUser]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersPut: function (updateUser, options) {
            return exports.UsersApiFp(configuration).apiV1UsersPut(updateUser, options)(axios, basePath);
        },
        /**
         *
         * @summary Get all available users.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersSelfGet: function (options) {
            return exports.UsersApiFp(configuration).apiV1UsersSelfGet(options)(axios, basePath);
        },
    };
};
/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
var UsersApi = /** @class */ (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Reset user password - for host/admin users only
     * @param {HostResetPasswordModel} [model]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1AccountHostresetpasswordPost = function (model, options) {
        return exports.UsersApiFp(this.configuration).apiV1AccountHostresetpasswordPost(model, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates user and context information (profile, actor etc.) from provided data
     * @param {CreateActorUser} [createActorUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1AccountOwnerUsersPost = function (createActorUser, options) {
        return exports.UsersApiFp(this.configuration).apiV1AccountOwnerUsersPost(createActorUser, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get profile departments.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1DepartmentsGet = function (options) {
        return exports.UsersApiFp(this.configuration).apiV1DepartmentsGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Look up for users from owner role.
     * @param {string} [name]
     * @param {string} [userName]
     * @param {string} [personIsoIdentifier]
     * @param {boolean} [showDisabled]
     * @param {string} [roles]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1OwnerUsersGet = function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
        return exports.UsersApiFp(this.configuration).apiV1OwnerUsersGet(name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get role by name.
     * @param {string} roleName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1RolesByRoleNameGet = function (roleName, options) {
        return exports.UsersApiFp(this.configuration).apiV1RolesByRoleNameGet(roleName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all roles of a user.
     * @param {string} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1RolesByUserNameRolesGet = function (userName, options) {
        return exports.UsersApiFp(this.configuration).apiV1RolesByUserNameRolesGet(userName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all roles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1RolesGet = function (options) {
        return exports.UsersApiFp(this.configuration).apiV1RolesGet(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Deletes user by user id.  DELETE: api/users/{userId}
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdDelete = function (userId, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdDelete(userId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Removes the actor for the provided userId and actorId
     * @param {string} userId
     * @param {number} actorId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdDepartmentsByActorIdDelete = function (userId, actorId, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdDepartmentsByActorIdDelete(userId, actorId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Adds an actor for provided userId and returns it
     * @param {string} userId
     * @param {CreateActor} [createActor]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdDepartmentsPost = function (userId, createActor, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdDepartmentsPost(userId, createActor, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdGet = function (userId, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdGet(userId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} userId
     * @param {string} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdRolesDelete = function (userId, role, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdRolesDelete(userId, role, options)(this.axios, this.basePath);
    };
    /**
     *
     * @param {string} userId
     * @param {string} [role]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdRolesPost = function (userId, role, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdRolesPost(userId, role, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Update roles.
     * @param {string} userId
     * @param {string} [roles]
     * @param {boolean} [notifyUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserIdRolesPut = function (userId, roles, notifyUser, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserIdRolesPut(userId, roles, notifyUser, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Returns user by user name.
     * @param {string} userName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersByUserNameGet = function (userName, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersByUserNameGet(userName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Disable user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersDisableByUserIdPut = function (userId, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersDisableByUserIdPut(userId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Enable user by user id.
     * @param {string} userId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersEnableByUserIdPut = function (userId, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersEnableByUserIdPut(userId, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Look up for users.
     * @param {string} [name]
     * @param {string} [userName]
     * @param {string} [personIsoIdentifier]
     * @param {boolean} [showDisabled]
     * @param {string} [roles]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersGet = function (name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersGet(name, userName, personIsoIdentifier, showDisabled, roles, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Creates a user.
     * @param {CreateUser} [createUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersPost = function (createUser, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersPost(createUser, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Update a user.
     * @param {UpdateUser} [updateUser]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersPut = function (updateUser, options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersPut(updateUser, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get all available users.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    UsersApi.prototype.apiV1UsersSelfGet = function (options) {
        return exports.UsersApiFp(this.configuration).apiV1UsersSelfGet(options)(this.axios, this.basePath);
    };
    return UsersApi;
}(base_1.BaseAPI));
exports.UsersApi = UsersApi;
